import React, { useEffect } from 'react';
import Instructions from 'components/Meteorology/Fields/ClassicComparator/Instructions';
import { setCurrentTab } from 'redux/reducers/meteorologyFieldsLayoutReducer';
import { store } from 'redux/store';
import useImages from 'hooks/Meteorology/Fields/ClassicComparator/useImages';
import buildImageDisplayData from 'helper/Meteorology/ClassicComparator/buildImageDisplayData';
import Toolbar from 'components/Meteorology/Fields/ClassicComparator/Toolbar';
import Display from 'components/Meteorology/Fields/Display';
import QueryErrorState from 'components/DesignSystem/QueryErrorState';
import CentralizedSpinner from 'components/CentralizedSpinner';
import useHandleImageRowSizeChange from 'utils/hooks/meteorology/useHandleImageRowSizeChange';
import useImagesDownload from 'utils/hooks/meteorology/classicComparator/useImagesDownload';
import useIsMobile from 'utils/hooks/useIsMobile';
import ClassicComparatorMobile from 'components/Meteorology/Fields/ClassicComparator/Mobile';

export default function ClassicComparator() {
  const {
    images, queryError, onRetry, isFetching,
  } = useImages();
  const {
    imageSets,
    columnLabels,
    rowLabels,
  } = buildImageDisplayData(images);
  const showInstructions = images === undefined && !queryError && !isFetching;

  useHandleImageRowSizeChange(columnLabels);

  const { downloadDisabled, onDownloadClick } = useImagesDownload(images);
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('classiccomparator'));
  }, []);

  if (isMobile) {
    return (
      <ClassicComparatorMobile
        showInstructions={showInstructions}
        imageSets={imageSets}
        columnLabels={columnLabels}
        rowLabels={rowLabels}
        onDownloadClick={onDownloadClick}
        downloadDisabled={downloadDisabled}
        isFetching={isFetching}
        queryError={queryError}
        onRetry={onRetry}
      />
    );
  }

  if (isFetching) {
    return (
      <div className="mt-5">
        <CentralizedSpinner />
      </div>
    );
  }

  if (showInstructions) {
    return <Instructions />;
  }

  if (queryError) {
    return (
      <div className="mt-5">
        <QueryErrorState
          title={queryError.data}
          message={queryError.description}
          onRetry={onRetry}
        />
      </div>
    );
  }

  return (
    <>
      <div className="mt-5 mx-5 d-flex justify-content-end">
        <Toolbar
          onDownloadClick={onDownloadClick}
          downloadDisabled={downloadDisabled}
        />
      </div>
      <Display
        imageSets={imageSets}
        columnLabels={columnLabels}
        rowLabels={rowLabels}
        fetchingImages={isFetching}
      />
    </>
  );
}
